/*
 * File: DemographicsApi.js
 * Project: mp-mobile-app
 *
 * Created by Jennifer Loecker on 09/17/2019
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: The demographic endpoints
 */
import { Http } from "api/Http";

const Api = new Http("patients/1/patient");

class PatientsApi {
  constructor(api) {
    this.api = api;
  }

  create = async patient => {
    let res = await this.api.post("", patient);
    return res.data || {};
  };

  update = async patient => {
    let res = await this.api.patch("/" + patient.patientId, patient);
    return res.data || {};
  };

  defaultPatient = async () => {
    let res = await this.api.get("/default");
    return res.data || {};
  };
}

const newApi = new PatientsApi(Api);
export default newApi;
